import type { $Fetch } from 'ofetch';
import type { Pagamento, RegistrarPagamentoCommand } from '@/domain/model/Pagamento';
import type { PagamentoGateway } from '@/application/port/out/PagamentoGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/pagamentos';

export class HttpPagamentoGateway implements PagamentoGateway {
  constructor(private readonly client: $Fetch) {}

  async listByParcela(parcelaId: string): Promise<Pagamento[]> {
    const res = await this.client<ApiResponse<Pagamento[]>>(
      `${PATH}/parcelas/${encodeURIComponent(parcelaId)}`, { method: 'GET' },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async listByVenda(vendaId: string): Promise<Pagamento[]> {
    const res = await this.client<ApiResponse<Pagamento[]>>(
      `${PATH}/vendas/${encodeURIComponent(vendaId)}`, { method: 'GET' },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async registrarManual(command: RegistrarPagamentoCommand): Promise<Pagamento> {
    const res = await this.client<ApiResponse<Pagamento>>(
      `${PATH}/registrar-manual`, { method: 'POST', body: command },
    );
    assertApiSuccess(res);
    return res.data;
  }
}
